import fetch from '@/plugin/axios'

export function getCountList(data) {
  return fetch({
    url: '/api/case/czCaseInfo/getCountList',
    method: 'post',
    data
  })
}
